module.exports = __webpack_public_path__ + "img/LV1.09d0f8fd.webp";